<template>
  <div class="modal">
    <div class="modal__box">
      <div class="modal__box__close">
        <div class="modal__box__close__icon" @click="close()">
          <icon-big-close />
        </div>
      </div>
      <div class="modal__box__title">
        <slot name="title"></slot>
      </div>
      <div class="modal__box__desc">
        <slot name="desc"></slot>
      </div>
      <div class="modal__box__content">
        <slot name="content"></slot>
      </div>
      <div class="modal__box__link">
        <slot name="link"></slot>
      </div>
      <div class="modal__box__buttons">
        <slot name="buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { clickOutside } from '@/directives/'
export default {
  directives: {
    'click-outside': clickOutside
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    outside: function () {
      this.$emit('close')
    }
  }
}
</script>